module.exports = __webpack_public_path__ + "img/6b52e784117b7dccaeb9f0d9bba01be5.png";